import { percent } from 'utils/math'

import { normalizeActor } from './actor'
import { defaultProgress } from './inputGroup'
import { defaultJourney, normalizeJourney } from './journey'

// Journey Actor Map (JAMap)
export const defaultJourneyActor = Object.freeze({
  id: '',
  shortId: '',
  // openId: '',
  currentId: '',
  progress: defaultProgress,
  journey: defaultJourney,
  actor: {},
  _normal: false
})

export function useOpen({ openId }, currentId, journey) {
  if (openId) {
    openId = openId.toLowerCase()
    const altId = journey.milestonesL.find((id) => {
      const m = journey.milestonesD[id]
      return m.name.toLowerCase() === openId || m.id === openId
    })
    if (altId) openId = altId
  } else {
    openId = currentId
  }
  let open = {}
  for (const id of journey.milestonesL) {
    open[id] = true
    if (openId === id) break
  }
  return { milestones: open, openId }
}

////////////////////////////////////////////////////////////////////////////////
export function normalizeJourneyActor({
  journey,
  actor,
  milestoneId: currentId,
  id,
  shortId,
  updatedAt,
  insertedAt,
  _normal,
  ...rest
}) {
  actor = normalizeActor(actor || {})
  journey = normalizeJourney(journey, actor)
  // const milestonesOpen = normalizeOpenMilestones(journey)

  const { progress, input2group } = summarizeJourneyProgress(journey)
  const inserted = new Date(insertedAt).getTime()
  const ageDays = (Date.now() - inserted) / 1000 / 86400

  return Object.freeze({
    id,
    shortId,
    progress,
    input2group,
    journey,
    actor,
    // milestonesOpen,
    // openId,
    // current,
    currentId,
    updatedAt,
    insertedAt,
    ageDays,
    _normal: true
  })
}

////////////////////////////////////////////////////////////////////////////////
// input: Journey with enriched groupsL/D
export function summarizeJourneyProgress({ groupsL, groupsD }) {
  const [progress, input2group] = groupsL.reduce(
    ([progress, input2group], groupId) => {
      const group = groupsD[groupId]
      if (group.progress) {
        progress.total += group.progress.total
        progress.finished += group.progress.finished
        progress.feedback += group.progress.feedback
        progress.returned += group.progress.returned
        progress.submitted += group.progress.submitted
        progress.working += group.progress.working
      }

      input2group = group.iLinksL.reduce((input2group, iLinkId) => {
        const iLink = group.iLinksD[iLinkId]
        input2group[iLink.input.id] = [group.shortId, iLink.shortId]
        return input2group
      }, input2group)
      return [progress, input2group]
    },
    [{ ...defaultProgress }, {}]
  )
  progress.percent = percent(progress.finished / progress.total)
  return { progress, input2group }
}
